import { Component, EventEmitter, Input, OnInit, Output, NgZone } from "@angular/core";
import { Observable, Subject, Subscription, takeUntil } from "rxjs";
import { EntityType } from "src/app/enums/entity-type.enum";
import { HachrazaDto } from "src/app/models/hachraza-dto";
import { ApiService } from "src/app/services/api.service";
import { RoutingService } from "src/app/services/routing.service";
import { DatePipe } from '@angular/common';
import { Entity } from "src/app/models/mvp-query-response-dto";
import { ActivatedRoute, Router } from "@angular/router";
import { SearchService } from "src/app/services/search.service";

import { ScreenDimensionsService } from "src/app/services/screen-dimensions.service";
import { ENTITY_MENU_CATEGORIES } from "src/app/constants";
import { MenuItem } from "primeng/api";
import { AuthService } from "src/app/services/auth.service";
import { WindowOpennerService } from "src/app/services/window-openner.service";
import { GaService } from "src/app/services/ga.service";
import { ARCGIS_MAP_LIFECYCLE } from "../arcgis-map/constants/map-life-cycle.interface";
import { MainMapService } from "../arcgis-map/services/main-map.service";
import { ControlType } from "../arcgis-map/constants/control-type.enum";
import { MapControlItem } from "../arcgis-map/constants/map-control-item.interface";

@Component({
  selector: 'hachraza',
  templateUrl: './hachraza.component.html',
  styleUrls: ['./hachraza.component.scss'],
    providers: [
      {
        provide: ARCGIS_MAP_LIFECYCLE,
        useClass: MainMapService,
      },
    ]
})
export class HachrazaComponent implements OnInit {
  menuCategories = ENTITY_MENU_CATEGORIES;
  closeClicked: Subject<void> = new Subject<void>();
  entity: Entity = {} as Entity;
  @Output() onShapeLeftClick = new EventEmitter<any[]>();
  @Input() currentLanguage!: Observable<string>;
  private entityDetailsSubscription?: Subscription;
  entityId: number = -1;
  rowsValues: any[] = [];
  hachrazaLoading: boolean = false;
  hachrazaDetails: HachrazaDto | null = null;
  shapes: any[] = [];
  zoomShapeIds: string[] = [];
  activatedRoute: ActivatedRoute | null | undefined;
  activeTab: MenuItem = this.menuCategories[0];
  tabIndex = 0;
  isSmallScreen = false;
  isAuthenticated = false;
  hebDetailsVisible: boolean = false;
  engDetailsVisible: boolean = false;
  private publicationsLink = 'https://www.gov.il/he/departments/dynamiccollectors/gazette-official?FolderType=2&skip=0'
  private internalUser: boolean = false;
  private internalUserSubscription?: Subscription;
  mapControls: MapControlItem[] = [
    { position: 'top-left', type: ControlType.FullScreen },
    { position: 'top-left', type: ControlType.Zoom },
    {
      position: 'top-left',
      type: ControlType.Print,
      attributes: {
        allowedFormats: 'all',
        allowedLayouts: 'all',
        printServiceUrl:
          'https://gis.israntique.org.il/arcgis/rest/services/IAAPrintTemplates/IAAPrintTemplateGrid25000/GPServer/Export%20Web%20Map',
      },
      expand: {
        id: 'print-expand',
        position: 'top-left',
        expandIcon: 'print',
        expandTooltip: 'הדפסה',
        mode: 'floating',
      },
    },
    {
      position: 'top-left',
      type: ControlType.BasemapGallery,
      expand: {
        id: 'basemap-gallery-expand',
        position: 'top-left',
        expandIcon: 'basemap',
        expandTooltip: '',
        mode: 'floating',
      },
    },
    {
      position: 'top-left',
      type: ControlType.Locate,
      attributes: { scale: 5000 },
    },
  ];

  constructor(
    private router: Router, private route: ActivatedRoute,
    private routingService: RoutingService,
    private apiService: ApiService,
    private screenDimensionsService: ScreenDimensionsService,
    private opener: WindowOpennerService,
    private gaService:GaService,
    private authService: AuthService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.screenDimensionsService.isSmallScreen$.subscribe(isSmallScreen => {
      this.isSmallScreen = isSmallScreen;
    });

    this.entityDetailsSubscription = this.routingService.entityDetails$.subscribe(entityDetails => {
      this.ngZone.run(() => {
        const { id, type } = entityDetails;
        if (!!id && type === EntityType.HACHRAZA) {
          this.entityId = id;
          this.getHachrazaDetails();
        }
      });
    });

    this.internalUserSubscription = this.authService.internalUser$.subscribe((isInternalUser) => {
      this.internalUser = isInternalUser;
    });
  }
  onActiveTabChange(event: MenuItem) {
    this.activeTab = event;
    this.tabIndex = this.menuCategories.findIndex((category) => category.label === event.label);
  }

  ngOnDestroy(): void {
    this.entityDetailsSubscription?.unsubscribe();
    this.internalUserSubscription?.unsubscribe();
  }
  convertShapesArray(shapes: any[]): any[] {
    return shapes.map((shape) => this.convertToConvertedShape(shape));
  }
  convertToConvertedShape(shape: any): any {
    const entity = shape.shapeData.entity;
    return {
      shapeId: shape.shapeId.toString(),
      wkt: shape.shapeWkt,
      layerName: "שכבת תוצאות שאילתה",
      hidden: false,
      isExtent: true,
      shapeData: {
        entity: {
          entityId: entity.entityId,
          entityType: entity.entityType
        },
      },
      styledParams: {
        geometryType: "Polygon", // Assuming default geometry type is Polygon
        fillColor: [106, 90, 205, 0.5],
        borderColor: [106, 90, 205, 0.9],
        borderWidth: 2,
      },
    };
  }
  goTo(entityType: string): void {
    // Close entity page and navigate to search results with filters
    this.routingService.navigateWithMerge({ 
      entityType: undefined,
      entityId: undefined,
      hachrazot: this.entityId, 
      entityTypes: entityType 
    });
  }
  handleLeftClick(shapes: any[]) {
    // what should we do on left click on hacharza shape
  }
  getChafiraShapes() {
    if (this.hachrazaDetails) {
      let convertedShapesForSelectedHachraza: any[] = this.convertShapesArray(this.hachrazaDetails.atarMapInformation as any)
      convertedShapesForSelectedHachraza.forEach((shape: any) => {
        shape.styledParams.fillColor = [106, 90, 205, 0.5];
        shape.styledParams.borderColor = [106, 90, 205];
      });
      this.shapes = this.shapes.concat(convertedShapesForSelectedHachraza);
      this.zoomShapeIds = [
        ...convertedShapesForSelectedHachraza.map(shape => shape.shapeId)
      ];
    }

  }
  getHachrazaDetails() {
    this.hachrazaLoading = true;
    this.apiService
      .getHachrazaDetails(this.entityId)
      .pipe(takeUntil(this.closeClicked))
      .subscribe({
        next: (res: HachrazaDto) => {
          this.hachrazaDetails = res;
        },
        error: () => {
          this.hachrazaLoading = false;
        },
        complete: () => {
          this.hachrazaLoading = false; this.getChafiraShapes()
        }
      });
  }
  showHebDialog() {
    this.hebDetailsVisible = true;
  }
  showEngDialog() {
    this.engDetailsVisible = true;
  }

  goPublicationsNotebook(ilkutNum: number, publicationDate: Date) {
    const fromDate = new Date(publicationDate);
    const toDate = new Date(publicationDate);
    toDate.setDate(toDate.getDate() + 1);
  
    const format = (d: Date) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
  
    const formattedFrom = format(fromDate);
    const formattedTo = format(toDate);
    this.gaService.trackWithGA('Yalkout Pirsoumim', 'entityType');
    this.opener.openUrlInNewTab(
      `${this.publicationsLink}` +
      `&BookletNum=${ilkutNum}` +
      `&PublishDate_from=${formattedFrom}` +
      `&PublishDate_to=${formattedTo}`
    );
  }
}